// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Dynamic report'">
    <button class="btn btn-primary"
              ng-disabled="!\$ctrl.report.id"
              command-access="UpdateDynamicReport"
              type="button"
              ng-click="\$ctrl.addNew()">
        Add new file
      </button>
    </sub-header>

  <div class="report-name">
    <form name="\$ctrl.nameForm">
      <form-section form-title="'Report details'">
        <form-section-field field-title="'Report name'">
          <input ng-model="\$ctrl.report.name" required type="text">
        </form-section-field>
      </form-section>
    </form>
  </div>

  <table class="table table--generate-row-ids table--last-column-to-right" ng-if="\$ctrl.report.files.length !== 0">
    <thead>
      <tr>
        <th>No</th>
        <th>File</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody class="tbody">
      <tr ng-repeat="file in \$ctrl.report.files">
        <td></td>
        <td>{{file.name}}</td>
        <td class="table__actions">
          <button class="btn btn-warning"
                  ng-click="\$ctrl.edit(file)"
                  command-access="UpdateDynamicReport"
                  type="button"
          >
            Edit
          </button>
          <button class="btn btn-danger"
                  ng-click="\$ctrl.delete(file)"
                  command-access="UpdateDynamicReport"
                  type="button">
            Delete
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-warning"
      ng-click="\$ctrl.cancelChanges()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-success"
      ng-disabled="\$ctrl.nameForm.\$invalid"
      ng-click="\$ctrl.save()">
      Save changes
    </button>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/dynamic-report/dynamic-report.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;